export const state = {
    preloader: false,
};
